import Vue from 'vue';
import vuetify from './plugins/vuetify';
import VueCompositionApi from '@vue/composition-api';
import App from './App.vue';
import router from './router/router';
import store from './store/Store';

Vue.config.productionTip = false;

Vue.use(VueCompositionApi);

new Vue({
  vuetify,
  store,
  router,
  render: h => h(App),
}).$mount('#app');
